export default __webpack_public_path__ + "static/media/GalanoGrotesque-ExtraBold.8950f6d4.woff2";